import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { setGlobalCurrency, getGlobalCurrency } from "utils/currency";

function CurrencyDropdown({ onChange }) {
  const [currency, setCurrency] = useState(getGlobalCurrency());

  const handleChange = (e) => {
    const value = e.target.value;
    setCurrency(value);
    setGlobalCurrency(value);

    if (onChange) onChange(value);

    window.dispatchEvent(new Event("currencyChanged")); // 🔥 notify all pages
  };

  return (
    <Form.Select
      size="sm"
      value={currency}
      onChange={handleChange}
      style={{ width: "110px" }}
    >
      <option value="LRD">LRD</option>
      <option value="USD">USD</option>
    </Form.Select>
  );
}

export default CurrencyDropdown;